import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const BannerSectionFour = () => {
  const [banner, setBanner] = useState([]);

  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/banner`)
      .then((res) => res.json())
      .then((info) => setBanner(info));
  }, []);

  const handleBannerSection = (event) => {
    event.preventDefault();
    const bannerHeading = event.target.bannerHeading.value;
    const bannerDetails = event.target.bannerDetails.value;
    const bannerText = event.target.bannerText.value;
    const imageOne = event.target.imageOne.value;
    const buttonText = event.target.buttonText.value;
    const buttonURL = event.target.buttonURL.value;
    const buttonTextTwo = event.target.buttonTextTwo.value;
    const buttonURLTwo = event.target.buttonURLTwo.value;
    const bannerTextTwo = event.target.bannerTextTwo.value;

    const bannerSection = {
      bannerHeading,
      bannerDetails,
      bannerText,
      imageOne,
      buttonText,
      buttonURL,
      buttonTextTwo,
      buttonURLTwo,
      bannerTextTwo,
    };

    const url = `https://ai-automation-audit-01-e0855711738d.herokuapp.com/add-banner`;
    fetch(url, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(bannerSection),
    })
      .then((res) => res.json())
      .then((result) => {
        alert('Banner is Updated');
      });
  };

  return (
    <>
   


      <div>
        <section id="services" className="services-area d-flex align-items-center vh-100 ">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 col-md-12 text-center">
                <h2 className="mb-5 mt-5">Update Banner</h2>

                {banner.length === 1 && (
                  <>
                    {banner.map((c) => (
                      <Link className="theme-btn btn-one mb-4" to={`/banner-four/${c._id}`}>
                        Edit Banner Section
                      </Link>
                    ))}
                  </>
                )}
                {banner.length === 0 && (
                  <form className="contact-form text-center" onSubmit={handleBannerSection}>
                    <div className="row">
                      <div className="col-lg-12 col-md-12 mb-3">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control mb-3"
                            name="bannerHeading"
                            placeholder="Banner Heading One"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 mb-3">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            name="bannerTextTwo"
                            placeholder="Banner Heading Two"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 mb-3">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            name="bannerText"
                            placeholder="Banner Heading Three"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-12 mb-3">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            name="bannerDetails"
                            placeholder="Banner Details"
                            required
                          />
                        </div>
                      </div>
                     
                      <div className="col-lg-12 col-md-12 mb-3">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            name="imageOne"
                            placeholder="Banner Image"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 mb-3">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            name="buttonText"
                            placeholder="Button Text"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 mb-3">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            name="buttonURL"
                            placeholder="Button URL"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 mb-3">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            name="buttonTextTwo"
                            placeholder="Second Button Text"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 mb-3">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            name="buttonURLTwo"
                            placeholder="Second Button URL"
                            required
                          />
                        </div>
                      </div>

                      <div className="slider-btn text-center">
                        <button className="theme-btn btn-one" data-animation="fadeInRight" data-delay=".8s">
                          Add Banner
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default BannerSectionFour;
